export default __webpack_public_path__ + "static/1355-e5b6bbc6bb1eaa3ad83a92611b6341d7.gif";